import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { SEO, SITE } from "../content/site";

const TITLES = {
  "/": "TJ's Light Foundation — No one should have to struggle in silence",
  "/about": "About TJ — TJ's Light Foundation",
  "/support": "Get Support — TJ's Light Foundation",
  "/walking-for-hope": "Walking for Hope — TJ's Light Foundation",
  "/get-involved": "Get Involved — TJ's Light Foundation",
  "/news": "News & Updates — TJ's Light Foundation",
  "/photos": "Photos — TJ's Light Foundation",
  "/contact": "Contact — TJ's Light Foundation",
  "/privacy": "Privacy — TJ's Light Foundation",
  "/accessibility": "Accessibility — TJ's Light Foundation",
};

export const Layout = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    const seoEntry = SEO.find((s) => s.path === pathname);
    document.title = seoEntry?.title || TITLES[pathname] || TITLES["/"];
    const description = seoEntry?.description;
    if (description) {
      document
        .querySelector('meta[name="description"]')
        ?.setAttribute("content", description);
    }
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);

  return (
    <div className="flex min-h-screen flex-col">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:rounded-md focus:bg-gold focus:px-4 focus:py-2 focus:font-semibold focus:text-ink"
        data-testid="skip-to-content-link"
      >
        Skip to main content
      </a>
      {window.__TJ_PREVIEW && (
        <div className="bg-gold-soft px-4 py-2 text-center text-xs font-semibold text-ink" role="status" data-testid="preview-banner">
          You are previewing unpublished changes — only signed-in administrators see this version.
        </div>
      )}
      <Header />
      {SITE.notice ? (
        <div className="border-b border-plum/20 bg-plum-soft px-4 py-2.5 text-center text-sm font-medium text-ink" role="status" data-testid="site-notice">
          {SITE.notice}
        </div>
      ) : null}
      <main id="main-content" className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};
